function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMerkmalEigenmarke({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10,
    cy: 10,
    r: 10,
    style: {
      fill: "#e41513",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.55 1.93C8.09 2 7.33 3.25 7.27 5.13a12.27 12.27 0 0 0 .67 2.93 8.5 8.5 0 0 1 2.11.12A12.68 12.68 0 0 1 12.5 9a7 7 0 0 0-2 3.74c-.12.77 0 1.57-.15 2.34a2.76 2.76 0 0 1-3.11 2.2s3.49 2.2 6.15-.49A5.09 5.09 0 0 0 14.3 11c-1-2-3-4.59-3.93-6.72-.71-1.72 1.21-2 1.21-2a4.74 4.74 0 0 0-2.03-.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10 12.23A4.36 4.36 0 0 1 12.5 9c-6-2-7.56 1.49-7.9 2.76 1.56-1.76 3.85-1.57 5.4.47Z",
    style: {
      fill: "#76b82a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMerkmalEigenmarke);
export default __webpack_public_path__ + "static/media/icon-merkmal-eigenmarke.9c1bb9e8c1d023df4ff41cc7746263b9.svg";
export { ForwardRef as ReactComponent };